import React from "react";
import { useTranslation } from "react-i18next";

import { VisibilitySwitch } from "@common/visibilitySwitch";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { Props } from "./types";
import { Form } from "./form";
import styles from "./styles.scss";

function TaskCreationWrapper({
  rootList,
  status,
  children,
  column,
  range,
  project,
  isSwitchDisabled,
}: Props) {
  const { t } = useTranslation();

  return (
    <VisibilityWatcher>
      {(isFormVisible, showForm, hideForm) => (
        <VisibilitySwitch
          renderChildren={(isVisible, show, hide) => (
            <div
              className={styles.taskCreationWrapper}
              onMouseEnter={() => !isSwitchDisabled && show()}
              onMouseLeave={() => !isSwitchDisabled && hide()}
            >
              {!isSwitchDisabled && children}
              {isFormVisible ? (
                <div className={styles.form}>
                  <Form
                    status={status}
                    rootList={rootList}
                    column={column}
                    project={project}
                    range={range}
                    done={hideForm}
                  />
                </div>
              ) : (
                (isVisible || isSwitchDisabled) && (
                  <div
                    className={styles.button}
                    onClick={(e) => {
                      e.stopPropagation();
                      showForm();
                    }}
                  >
                    <p className={styles.text}>
                      + {t("kanban.taskCreation.addTask")}
                    </p>
                  </div>
                )
              )}
            </div>
          )}
        />
      )}
    </VisibilityWatcher>
  );
}

export { TaskCreationWrapper };
